/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/mv_zip.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Combines the values from two multivalued fields with a delimiter that joins them together.
 *
 * @example
 * ROW a = ["x", "y", "z"], b = ["1", "2"]
 * | EVAL c = mv_zip(a, b, "-")
 * | KEEP a, b, c
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'mv_zip',
  signatures: [
    {
      params: [
        {
          name: 'string1',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'string2',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'string1',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'string2',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'delim',
          type: 'keyword',
          optional: true,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'string1',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'string2',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'delim',
          type: 'text',
          optional: true,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'string1',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'string2',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'string1',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'string2',
          type: 'text',
          optional: false,
        },
        {
          name: 'delim',
          type: 'keyword',
          optional: true,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'string1',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'string2',
          type: 'text',
          optional: false,
        },
        {
          name: 'delim',
          type: 'text',
          optional: true,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'string1',
          type: 'text',
          optional: false,
        },
        {
          name: 'string2',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'string1',
          type: 'text',
          optional: false,
        },
        {
          name: 'string2',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'delim',
          type: 'keyword',
          optional: true,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'string1',
          type: 'text',
          optional: false,
        },
        {
          name: 'string2',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'delim',
          type: 'text',
          optional: true,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'string1',
          type: 'text',
          optional: false,
        },
        {
          name: 'string2',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'string1',
          type: 'text',
          optional: false,
        },
        {
          name: 'string2',
          type: 'text',
          optional: false,
        },
        {
          name: 'delim',
          type: 'keyword',
          optional: true,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'string1',
          type: 'text',
          optional: false,
        },
        {
          name: 'string2',
          type: 'text',
          optional: false,
        },
        {
          name: 'delim',
          type: 'text',
          optional: true,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
